import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ReferenceDataCacheService } from '../commonservice/reference-data-cache.service';

@Injectable({
  providedIn: 'root'
})

export class TeamsService {   
    constructor(
        private http: HttpClient,
        private referenceDataCache: ReferenceDataCacheService
    ) {}

    CreateNewTeam(team){
        return this.http.post<any>('Teams/Create', team);
    }

    CreateNewGroup(team){
        return this.http.post<any>('TeamGroups/Create', team);
    }

    GetTeams() {
        return this.http.get<any>('Teams/Teams');
    }

    UpdateTeam(team) {
        return this.http.post<any>('Teams/Update', team);
    }

    UpdateGroup(group){
        return this.http.post<any>('TeamGroups/Update', group);
    }

    AddGroupMembers(data){
        return this.http.post<any>('TeamGroupMembers/AddMembers', data);
    }

    UpdateGroupMember(data){
        return this.http.post<any>('TeamGroupMembers/Update', data);
    }

    UpdateGroupPrivilege(data){
        return this.http.post<any>('TeamGroups/UpdatePrivilege', data);
    }

    UpdateGroupMemberPrivilege(data){
        return this.http.post<any>('TeamGroupMembers/UpdatePrivilege', data);
    }

    DeleteTeam(teamId: number) {
        return this.http.delete<any>(`Teams/Delete?teamId=${teamId}`);
    }

    GetTeamGroups(teamId: number){
        return this.http.get<any>(`TeamGroups/TeamGroups?teamId=${teamId}`);
    }

    DeleteGroup(groupId:number){
        return this.http.delete<any>(`TeamGroups/Delete?groupId=${groupId}`);
    }

    DeleteGroupMember(id:number,groupId:number,memberId:string){
        return this.http.delete<any>(`TeamGroupMembers/Delete?id=${id}&groupId=${groupId}&memberId=${memberId}`);
    }

    GetTeamsForCombo(){
        return this.referenceDataCache.getTeamsForCombo();
    }
}